import React from "react";
import { Check } from "lucide-react";

const ToggleSwitch = ({ isActive, onToggle, disabled = false }) => {
  return (
    <div className="landing-toggle-container">
      <button
        className={`landing-toggle-switch ${isActive ? "active" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={onToggle}
        disabled={disabled}
      >
        <div className="landing-toggle-slider">
          {isActive && <Check size={12} />}
        </div>
      </button>
      {isActive && (
        <div className="landing-toggle-badge">
          <Check size={14} />
          Active
        </div>
      )}
    </div>
  );
};

export default ToggleSwitch;
